import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { fetchBWInMedia } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import Helmet from 'react-helmet';
import './BlogPage.css';

import News from '../components/News';

class BWInMediaPage extends Component {
  constructor() {
    super();

    this.state = {
      limit: 5
    }
  }

  componentDidMount()
  {
    const locale = this.props.intl.locale;
    if (!this.props.bwinmedia.fields) {
      this.props.fetchBWInMedia(locale, this.state.limit);
    }
  }

  loadMore(locale, limit = 5) {
    const newLimit = this.state.limit+limit;
    this.setState({
      limit: newLimit
    })
    this.props.fetchBWInMedia(locale, newLimit);
  }

  render() {
    const locale = this.props.intl.locale;
    const {bwinmedia} = {...this.props};

    const slug = this.props.match.params.slug;

    let release;

    if(slug) {
      release = bwinmedia.find((p) => {
        return p.fields.slug === this.props.match.params.slug;
      })
    }

    return (
      <div className="news press">
        <Helmet>
          <title>{this.props.intl.messages["header.bwInMedia"]}</title>
        </Helmet>
        {!bwinmedia && <Loader/>}
        {release && <News release={release} visible url={window.location.href} />}
        {(!release && bwinmedia) && bwinmedia.map((release) => {
          if(release.fields.title && release.fields.lead) {
            return(
              <News key={release.sys.id} release={release} url={window.location.href+'/'+release.fields.slug} />
            )
          }          
          return null;
        })}
        {((!release && bwinmedia) && (this.state.limit <= bwinmedia.length)) && 
          <div className="load-more" onClick={() => this.loadMore(locale)}>
            <span className="btn">{this.props.intl.messages["general.loadMore"]}</span>
          </div>
        }
      </div>
    );
  }
}

BWInMediaPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  bwinmedia: state.bwinmedia
});

const mapDispatchToProps = {
  fetchBWInMedia
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(BWInMediaPage));


// WEBPACK FOOTER //
// ./src/containers/BWInMediaPage.js